import React from 'react';
import { Flex } from 'antd';
import {
  colorBlue,
  colorGold,
  colorGray,
  colorGreen,
} from '@atlas-frontend/design-tokens';
import { TextEllipsis, Tooltip } from '../../common/components';
import styled from 'styled-components';
import {
  formatCodeName,
  formatDate,
  getDatePeriodString,
} from '../../common/utils';
import { UserCalendarDto, UserCalendarExecutionType } from './schema/types';

export interface UserCalendarDateCellProps {
  executionsByType?: Map<UserCalendarExecutionType, UserCalendarDto[]>;
}

export const UserCalendarDateCell = (props: UserCalendarDateCellProps) => {
  const { executionsByType } = props;

  if (!executionsByType) {
    return;
  }

  return (
    <Flex>
      <UserCalendarExecution
        color={colorBlue[2]}
        executions={executionsByType.get(UserCalendarExecutionType.IN_DEAD)}
      />
      <UserCalendarExecution
        color={colorGreen[4]}
        executions={executionsByType.get(UserCalendarExecutionType.OUT_DEAD)}
      />
      <UserCalendarExecution
        color={colorGold[6]}
        executions={executionsByType.get(UserCalendarExecutionType.OUT_PUB)}
      />
    </Flex>
  );
};

export interface UserCalendarExecutionProps {
  color: string;
  executions?: UserCalendarDto[];
}

export const UserCalendarExecution = (props: UserCalendarExecutionProps) => {
  const { color, executions } = props;
  if (!executions) return null;
  return (
    <Tooltip
      title={
        <TextEllipsis rows={16} renderTooltip={false}>
          {executions.map((execution) => {
            const codeName = formatCodeName(execution);
            const valueDate = execution.valueDate
              ? execution.valueDate
              : getDatePeriodString(execution.validFrom, execution.validTo);
            return (
              <div
                key={execution.code}
              >{`${codeName} (${formatDate(valueDate)})`}</div>
            );
          })}
        </TextEllipsis>
      }
    >
      <Oval $fill={color} $shadow={colorGreen[5]}>
        {executions.length}
      </Oval>
    </Tooltip>
  );
};

const Oval = styled.div<{ $fill: string; $shadow: string }>`
  background-color: ${(props) => props.$fill};
  font-weight: bold;
  text-shadow: 0 0 2px ${colorGray[7]};
  border-radius: 35%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: white;
  height: 14px;
  width: 18px;
`;
